(ns web3.screens.property
  (:require ["scroll-into-view" :as scroll-into-view]
            [web3.persistence.schema :as schema]
            [web3.persistence.queries :as q]
            [web3.queries.root :as q-root]
            [web3.queries.property :as q-property]
            [web3.components.widgets :as widgets]
            [web3.components.drawer :as drawer]
            [web3.components.select :as select]
            [web3.forms.fields :as fields]
            [web3.i18n :as i]
            [reagent.core :as r]
            [re-frame-simple.db :as db]
            [web3.utils :as utils]
            [web3.routing.core :as routing]
            [web3.persistence.graphql :as g]
            [web3.view :as v]
            [web3.forms.validation :as validation]
            [web3.persistence.deletions :as deletions]
            [web3.modals.forms :as forms]
            [web3.components.autocomplete :as autocomplete]
            [clojure.string :as str]
            [web3.ui-state :as ui-state]
            [web3.hints.core :as hints]
            [web3.log :as log]
            [goog.events :as g-events]
            [web3.modals.alerts :as alerts]
            [web3.constants :as constants]
            [web3.env :as env]
            [web3.tracking.components :as tc]
            [web3.routing.utils :as ru]
            [web3.persistence.current-property :as current-property]
            [web3.view.hiccup :as hiccup]
            [web3.components.text :as text]
            [web3.fuzzy-search :as fuzzy]
            [web3.components.icons :as icons]
            [web3.screens.pro.utils :as pro-utils]))

(def transfer-icon
  [:svg
   {:width "20px", :height "20px", :view-box "0 0 20 20", :preserve-aspect-ratio "xMidYMid meet"}
   [:defs {}]
   [:g
    {:stroke "none",
     :stroke-width "1",
     :fill "none",
     :fill-rule "evenodd",
     :stroke-linecap "round",
     :stroke-linejoin "round"}
    [:g
     {:transform "translate(-97.000000, -594.000000)", :stroke "currentColor"}
     [:g
      {:transform "translate(15.000000, 585.000000)"}
      [:path
       {:d "M83.271,18.7343 L92.136,23.6693 L101,18.7343 M100,13.0003 L96.068,13.0003 C93.859,13.0003 92.068,14.7903 92.068,17.0003 L92.068,20.0153 M96,17.0003 L100,13.0003 L96,9.0003 M101,16.9323 L101,27.9323 L83,27.9323 L83,16.9323 L87.417,16.9323"}]]]]])

(defn all-properties []
  (->> (q-root/me)
       :me
       :propertyRights
       (map :property)))

(defn get-property [id]
  (utils/find-first #(= (:id %) id) (all-properties)))

(defn get-current-property
  "Get current property.

  If `id` is nil, chooses the first property in the user's property list."
  ([] (get-current-property nil))
  ([property-id]
   (let [id (current-property/get-id property-id)
         properties (all-properties)]
     (if id
       (or (utils/find-first #(= (:id %) id) properties)
           (first properties))
       (first properties)))))

(defn property-nickname
  [path->props]
  (fields/from-schema :Property/nickname
                      (-> (path->props [:nickname])
                          (assoc :suggested-value
                                 (when-let [city (:value (path->props [:address :locality]))]
                                   (i/get :property/default-nickname {:city city}))))))


(defn property-fields [path->props]
  [:div
   (fields/from-schema :StreetAddress/street1 (-> (path->props [:address :street1])
                                                  (assoc :id "input-property-street1")))
   (fields/from-schema :StreetAddress/street2 (path->props [:address :street2]))
   [:div.flex
    (fields/from-schema :StreetAddress/locality (path->props [:address :locality]))
    [:div.margin-right-3]
    [:div.flex-auto
     (fields/from-schema :StreetAddress/region (path->props [:address :region]))]]
   (fields/from-schema :StreetAddress/postalCode (path->props [:address :postalCode]))
   (property-nickname path->props)])


(defn delete-property [property]
  (let [property-params {:name (:nickname property)
                         :count-groups (count (:assetGroups property))
                         :count-contents (count (:contents property))
                         :count-assets (count (mapcat :assets (:assetGroups property)))}]
    (deletions/delete-with-confirm
      (merge property
             {:text-primary
              (i/get :property/delete.primary property)
              :text-secondary
              (i/get :property/delete.secondary)
              :confirm
              {:text-primary (i/get :property/delete.confirm-contents.primary
                                    property-params)
               :text-secondary (i/get :property/delete.confirm-contents.secondary
                                      property-params)}
              :mutate!
              (partial q-property/property-delete! {:id (:id property)})
              :snack (i/get :property/delete-complete)
              :redirect (routing/path-for [:properties/index])}))))

(v/defview detail
  {:header {:title (i/get :i/property-details)}}
  [{:keys [property-id] :as xx}]
  (let [{:keys [state]} (r/current-component)
        {{property-id :id
          :keys [propertyTransferRequest]
          :as property} :entity
         :as query} (q-property/property-deletion-content-check {:id property-id})
        property-mutation! (fn [path this value opts]
                             (q-property/property-update!
                               (-> (select-keys property [:id :nickname :address])
                                   (assoc-in path value)
                                   ;; must remove __typename (not a valid field)
                                   ;; and empty values (not allowed by graphql mutations)
                                   (update :address dissoc :__typename)
                                   (update :address utils/remove-empty-vals))
                               (merge {:component this}
                                      opts)))
        delete-this-property! (partial delete-property property)]
    [:div
     (when propertyTransferRequest
       [:div.bg-light-green.pad-all-3.flex.items-center
        (-> transfer-icon
            (hiccup/class "margin-right-2")
            (hiccup/size 32))
        (i/get :transfer/in-progress-message propertyTransferRequest)])
     [:div.pad-all-3

      [widgets/graphql-state (-> (or (g/mutation-state)
                                     query)
                                 (assoc :negative-pad? true))]
      (property-fields (fn [path]
                         {:read-only? false
                          :persist-value! (partial property-mutation! path)
                          :persisted-value (get-in property path)}))
      [:<>
        (if propertyTransferRequest
          [widgets/primary-button
           {:key :transfer/cancel
            :on-click #(alerts/add-frame [alerts/property-transfer-withdraw
                                          {:mutate! (fn [options]
                                                      (q-property/property-transfer-cancel!
                                                        {:propertyId property-id}
                                                        (merge options
                                                               {:refetch [q-root/me]
                                                                :on-error (fn []
                                                                            (g/once q-root/me
                                                                                    {}
                                                                                    {:on-complete
                                                                                     (fn [] (routing/nav!
                                                                                              (routing/path-for :router/drawer [:properties/index]
                                                                                                                :router/root [:blank/authed])))}))})))
                                           :text-primary (i/get :i/are-you-sure)
                                           :text-action (i/get :i/transfer-property-withdraw)}])
            :class "border-gray margin-bottom-3"}
           (i/get :i/transfer-property-withdraw)]
          (when property-id
            [widgets/primary-button
             {:key :transfer/start
              :href (routing/path-for [:property-transfer/create.start :property-id property-id])
              :class "border-gray margin-bottom-3 flex text-black hover-text-black-hover"}
             (-> transfer-icon
                 (hiccup/class "pad-right-2"))
             (i/get :i/transfer-property)]))
        #_[widgets/primary-button
           {:key :duplicate
            :href (routing/path-for [:property/duplicate :property-id property-id])
            :class "border-gray margin-bottom-3 flex text-black hover-text-black-hover"}
           (i/get :i/duplicate-property)]
        [widgets/primary-button
         {:key :delete
          :on-click delete-this-property!
          :class "border-gray margin-bottom-3"}
         (i/get :i/delete)]
        [widgets/black-button
         {:key :done
          :on-click #(routing/nav! (routing/path-for :router/drawer [:properties/index]))}
         (i/get :i/done)]]]]))


(v/defview index
  {:header {:title (i/get :i/my-properties)
            :content-right [widgets/edit-pencil-drawer [:edit :property]]}
   :component-did-mount (fn [{:keys [state]}]
                          ;
                          (when-let [drawer-ref (db/get-in [:refs :ref/drawer])]
                            (-> drawer-ref
                                (g-events/listenOnce goog.events.EventType.TRANSITIONEND
                                                     #(scroll-into-view (:current-property @state))))))
   :component-will-unmount (fn [{:keys [state]}]
                             (-> (db/get-in [:refs :ref/drawer])
                                 (g-events/removeAll goog.events.EventType.TRANSITIONEND)))}
  []
  (let [{:keys [state]} (r/current-component)
        properties (->> (get-in (q-root/me) [:me :propertyRights])
                        (map :property))

        property-filter (fuzzy/make-fuzzy-search-fn [[:property-nickname]
                                                     [:address :locality]
                                                     [:address :postalCode]
                                                     [:address :region]
                                                     [:address :street1]]
                                                    0.2)

        current-property-id (:id (get-current-property))
        edit-korks [:edit :property]
        edit? (routing/get-query edit-korks)
        mobile? (ui-state/mobile?)
        state-input-path  ::input
        filter-term (get @state state-input-path)
        is-filtered? (and (not (nil? property-filter)) (not (empty? filter-term)))
        filtered-objects (if is-filtered?
                           (property-filter filter-term properties 1000)
                           properties)

        properties (->> filtered-objects
                        (sort-by #(str (schema/property-nickname %)
                                       (get-in % [:address :street1])))
                        (mapv (fn [{:as property
                                    :keys [id propertyTransferRequest]}]
                                (let [[line-1 & lines] (schema/property-display-lines property)
                                      selected-property? (= id current-property-id)]
                                  [:div.pad-h-3
                                   [select/selectable-property-row
                                    {:key id
                                     :selected? selected-property?
                                     :ref #(when (and % selected-property?)
                                             (swap! state assoc :current-property %))
                                     :edit? edit?
                                     :on-select
                                     (if-not edit?
                                       #(routing/nav! (routing/path-for (if mobile?
                                                                          {:router/root [:home/property :property-id id]}
                                                                          [:home/property :property-id id])))
                                       (->> [:properties/detail :property-id id]
                                            (routing/path-for)
                                            (partial routing/nav!)))
                                     :on-expand-toggle #()
                                     :title
                                     [:div.flex.flex-auto.items-center
                                      (into [:div.flex-auto
                                             [:div.text-uppercase
                                              line-1]]
                                            (interpose [:br] lines))
                                      (when propertyTransferRequest
                                        (-> transfer-icon
                                            (hiccup/class "margin-left-2")))]}]]))))]


    (-> [:div
         (when (pro-utils/pro?)
          [:div.pad-h-3
           [text/input {:container {:style {:margin-right 0
                                            :margin-left "auto"}}
                        :label "Search"
                        :value (::input @state)
                        :kind :search
                        :on-change #(swap! state assoc state-input-path (.. % -target -value))
                        :content/inline-right (-> (icons/get "magnifying-glass")
                                                  (hiccup/size 16)
                                                  (hiccup/class "dark-gray"))

                        :helptext "Below will automatically update as you type!"
                        :helptext-persistent? false
                        :id "properties/search-input"
                        :loading? false}]])]
        (into
         (-> properties
             (interleave (repeat drawer/drawer-list-spacer))))
        (cond-> (not edit?) (conj
                             [:div.bg-off-white
                              {:style {:position :sticky
                                       :bottom "0px"}}
                              [drawer/bottom-button
                               {:on-click #(routing/set-query! edit-korks (not edit?))}
                               (i/to-do "Manage Properties")]
                              [drawer/bottom-button
                               {:href (routing/path-for [:add/property])}
                               (i/get :i/add-new-property)]])
                edit? (conj [:div.bg-off-white
                             {:style {:position :sticky
                                      :bottom "0px"}}
                             [drawer/bottom-button
                              {:on-click #(routing/set-query! edit-korks (not edit?))}
                              (i/to-do "Done")]])))))

(def property-frame {:key :property-list
                     :content [index]})

(defn formatted-property [property]
  (let [[line-1 & lines] (schema/property-display-lines property)]
    [:div.flex-none
     {:style {:min-width 236}}
     [:div.text-address.text-uppercase
      line-1]
     (into [:div.weight-regular.text-size-17.line-h-20]
           (interpose [:br] lines))]))

(v/defview actionable-property
  "Show the current property, with arrow for chooser."
  [{:keys [href] :as props} property]
  (let [[line-1 & lines] (schema/property-display-lines property)]
    [(if href :a :div)
     (-> props
         (update :class str " text-black margin-v-3 line-h-20 flex items-stretch cursor-pointer margin-v-2_5 "))
     (formatted-property property)
     (widgets/chevron-action {})]))

(defn welcome-flow? [this]
  (= "welcome" (some-> (:props this)
                       :handler
                       (namespace))))

(v/defview add-zip
  {:header {:title (i/get :i/create-your-property)}
   :component-did-mount
   (fn [this]
     (when (welcome-flow? this)
       (hints/show! [:hint/welcome.zip]))
     (utils/focus-first-input! this))}
  [props]
  (let [zip-value (forms/get-field [:address :postalCode])
        ;; the address form is always at the current path + /address
        add-address-path (routing/conj-segment :router/form-modal "address")
        {options :lookupZipcode
         loading? :graphql/loading?} (when (> (some-> (utils/some-str zip-value)
                                                      (count))
                                              4)
                                       (q-root/zip-lookup {:zipcode zip-value}))]
    [:div.flex-auto.flex.flex-column.pad-all-3
     [:form.flex-auto.round-4
      {:on-submit (fn [^js e]
                    (.preventDefault e)
                    (routing/nav! add-address-path))}
      [autocomplete/autocomplete
       {:on-change (fn [e]
                     (let [val (.. e -target -value)]
                       (when (string? val)
                         (forms/assoc-field! [:address :postalCode] val))))
        :label (i/get :i/postalCode)
        :id "input-property-zip"
        :value zip-value
        :loading? loading?
        :options (for [{:keys [city state] :as option} options]
                   {:value option
                    :label (str city ", " state)})
        :on-change* (fn [{{:as value
                           :keys [city state]} :value}]
                      (when value
                        (forms/swap-state!
                          update-in [::forms/data
                                     :address] merge {:locality city
                                                      :region state})
                        (routing/nav! add-address-path)))}]]
     [widgets/black-button
      {:href add-address-path}
      (i/get :i/next)]
     [:div.text-dark-gray.text-size-13.pre-wrap.margin-top-3
      "\n\nYour data is secure with us. We use bank-level security and encryption and never share or sell your contact information.\n\nFor more details, see our "
      [tc/a {:class "text-dark-gray text-underline"
             :href "https://www.homeserve.com/sc/legal/privacy-policy"
             :target "_blank"
             :rel "noopener"}
       "privacy policy"] "."]]))

(v/defview add-address
  {:header {:title (i/get :i/add-property)}
   :component-did-mount
   (fn [this]
     (hints/show! [:hint/welcome.address])
     (utils/focus-first-input! this))
   :component-will-mount
   (fn []
     (let [{{city :locality} :address
            display-name :nickname} (forms/form-data)]
       (when (and city
                  (or (not display-name)
                      (str/starts-with? display-name (subs (i/get :property/default-nickname) 0 5))))
         (forms/assoc-field! [:nickname] (i/get :property/default-nickname {:city city})))))}
  [{:as props}]
  (let [{:keys [state] :as this} (r/current-component)
        create-property!
        (fn [^js e]
          (.preventDefault e)
          (let [data (-> (forms/form-data)
                         (select-keys [:nickname :address])
                         (assoc-in [:address :country] "USA"))
                validations (schema/validate-property data)]
            (swap! state assoc :dirty? true)
            (when-not (validation/invalid? validations)
              (->> {:component this
                    :refetch [q-root/me]
                    :on-complete
                    (fn [^js payload]
                      (let [{:keys [id]} (-> payload
                                             (utils/->clj-map)
                                             (get-in [:data :property-create :property]))]
                        (db/dispatch [:assoc :current-property-id id]) ;; Make sure to set the property for pro-dash
                        (routing/nav! (cond (and (welcome-flow? this)
                                                 (ui-state/mobile?))
                                            (routing/path-for {:router/root [:home/property :property-id id]
                                                               :router/form-modal [:welcome/get-mobile]})

                                            (and (welcome-flow? this)
                                                 (not (ui-state/mobile?)))
                                            (if-let [vimeo-id (:feature/welcome-vimeo-id env/config)]
                                              (routing/path-for :router/root [:home] ;;TODO Refactor this duped code from welcome.cljs
                                                                :router/form-modal [:media/vimeo :vimeo-id vimeo-id])
                                              (routing/path-for {:router/root [:home]}))


                                            (= (ru/get-route) (routing/path-for [:pro/dashboard]))
                                            (routing/path-for {:router/root [:pro/dashboard]
                                                               :router/form-modal [:add/property.create-successful]})

                                            :else
                                            (routing/path-for {:router/root [:home/property :property-id id]
                                                               :router/form-modal [:add/property.create-successful]})))))}
                   (q-property/property-create! data)))))]
    [:div.flex-auto.pad-all-3.round-4
     [:form (-> props
                (v/merge-props {:on-submit create-property!}))
      [property-fields (fn [path]
                         {:change-value! #(forms/assoc-field! path %)
                          :value (forms/get-field path)
                          :dirty? (:dirty? @state)})]
      [widgets/graphql-submit-button
       {:label (i/get :i/create)
        :state (g/mutation-state)}]]]))

(v/defview create-successful
  {:header {:title (i/to-do "Property Created")}
   :component-did-mount
   (fn [this]
     (utils/focus-first-input! this))}
  [{:as props}]
  (let [{:keys [state] :as this} (r/current-component)
        property (current-property/get-property)]
    [:div.flex-auto.pad-all-3.round-4
     [:div.text-center.flex-none.weight-extra-light.text-size-28
      {:style {:padding-top "9%"
               :padding-bottom "9%"
               :color (:welcome/text constants/colors)}}
      "Property Created."]
     [:div.bg-white.round-3.pad-h-3.pad-v-3.shadow-card
      [:div.weight-semi-bold.text-size-20
       (schema/property-nickname property)]
      [:div.pad-v-3
       (->> (schema/property-display-lines property)
            (map #(identity [:div {:key %} %]))
            (drop 1))]                                      ;;GET THAT EXTRA PROPERTY NICKNAME OTTTA HERE!
      [:div.flex.flex-auto.flex-wrap
       [widgets/primary-button
        {:key :view-property
         :style {:flex-basis "100%"}
         :href (routing/path-for :router/root [:home]
                                 :router/form-modal nil)
         :class "border-gray margin-bottom-3 text-black"}
        (i/to-do "View Property")]
       [widgets/primary-button
        {:key :add-products
         :style {:flex-basis "100%"}
         :href (routing/path-for :router/form-modal [:add-anything/start])
         :class "border-gray margin-bottom-3 text-black"}
        (i/to-do "Add Products")]]]
     [:div.flex
      {:style {:padding-top "100px"}}
      [:div.pad-top-4.width-50p.pad-all-1.flex-auto.flex
       [widgets/black-button
        {:href (routing/path-for :router/form-modal nil)
         :class "width-100p"}
        "Done"]]
      [:div.pad-top-4.width-50p.pad-all-1.flex-auto.flex
       [widgets/black-button
        {:href (routing/path-for :router/form-modal [:add/property])}
        "Add Another"]]]]))


(def small-heading :div.text-size-13.text-uppercase.weight-medium.margin-v-3.text-dark-gray)
(def large-heading :div.text-size-20.weight-medium.line-h-24)
(def form-card :div.round-4.bg-white.pad-all-3.shadow-card)

(defn contact-details [{:keys [firstName lastName companyName email]}]
  [:div
   [large-heading firstName " " lastName]
   [:div.text-size-13.pre-wrap.line-h-17
    (->> [companyName email]
         (keep utils/some-str)
         (str/join \newline))]])

(v/defview transfer-start
  "Facilitate transfer of a property from one user to another"
  {:header {:title (i/get :i/transfer-property)}
   :component-did-mount utils/focus-first-input!}
  [{:keys [property-id]}]
  (let [{:as this
         :keys [state]} (r/current-component)
        property (get-property property-id)
        {:keys [firstName lastName companyName email] :as me} (:me (q-root/me))]
    [:form.pad-h-3.pad-bottom-3
     {:on-submit
      (partial forms/form-submit {:component this
                                  :required [:User/email]
                                  :submit! (fn [data]
                                             (q-property/property-transfer-start!
                                               (assoc data
                                                 :propertyId property-id)
                                               {:component this
                                                :on-complete (fn [e] (routing/nav! (routing/path-for :router/form-modal [:property-transfer/create.complete :property-id property-id])))}))})}

     [small-heading (i/get :i/property)]

     [form-card
      (formatted-property property)]

     [small-heading (i/get :i/transfer-to)]

     (doall
       (for [k [:User/firstName :User/lastName :User/email]]
         (fields/from-schema k (forms/field-props state k))))

     [small-heading (i/get :i/send-from)]

     [contact-details me]

     [widgets/graphql-submit-button {:label (i/get :i/transfer)
                                     :state (g/mutation-state this)}]]))

(v/defview transfer-submitted
  "Show the submitted transfer"
  {:header {:title (i/get :i/transfer-property)}}
  [{:keys [property-id]}]
  (let [{:as property
         :keys [propertyTransferRequest]} (get-property property-id)]
    [:div.pre-wrap.pad-all-3.height-100p.flex.flex-column
     [:div.text-size-24.weight-medium.line-h-30.text-center.margin-v-4
      (i/to-do "Success!\nThe property is on its way.")]

     [small-heading (i/get :i/transferring)]

     [form-card
      (formatted-property property)]

     [small-heading (i/get :i/to)]

     [contact-details propertyTransferRequest]

     [:div.text-size-20.weight-medium.line-h-24.margin-v-3
      (i/get :transfer/confirmation-message propertyTransferRequest)]
     [:div.flex-auto]
     [widgets/black-button
      {:href (routing/path-for :router/form-modal nil)
       :class "margin-v-3 flex"}
      (i/get :i/done)]]))

(v/defview duplicate
  {:header {:title (i/get :i/duplicate-property)}
   :get-initial-state (fn [{{:keys [property-id]} :props}]
                        {:property/nickname (schema/property-nickname (get-property property-id))})
   :component-did-mount utils/focus-first-input!}
  [{:keys [property-id]}]
  (let [{:as this
         :keys [state]} (r/current-component)
        property (get-property property-id)]
    [property-nickname (fn [path]
                         {:change-value! #(forms/assoc-field! path %)
                          :value (forms/get-field path)
                          :dirty? (:dirty? @state)
                          :required true})]
    [:div.pad-h-3.height-100p.flex.flex-column
     [small-heading (i/get :i/duplicate)]
     [form-card
      (formatted-property property)]
     [small-heading (i/get :i/duplicate-as)]
     [:form
      {:on-submit (partial forms/form-submit {:component this
                                              :submit! (fn [data]
                                                         (let [data (assoc data :propertyId property-id)]
                                                           (q-property/property-clone!
                                                             {:id (:propertyId data)
                                                              :nickname (:nickname data)}
                                                             {:component this
                                                              :on-complete (fn [e]
                                                                             (let [property-id (-> e
                                                                                                   utils/->clj-map
                                                                                                   :data
                                                                                                   :property-clone
                                                                                                   :property
                                                                                                   :id)]
                                                                               (routing/nav! (routing/path-for {:router/drawer [:properties/detail :property-id property-id]}))))})))})}
      [property-nickname (fn [path]
                           {:change-value! #(forms/assoc-field! path %)
                            :value (forms/get-field path)
                            :dirty? (:dirty? @state)})]

      [widgets/graphql-submit-button {:label (i/get :i/duplicate)
                                      :state (g/mutation-state this)}]]
     [:div.margin-v-3.text-size-14.weight-medium
      (i/to-do "Duplicating a property will create a new property and copy all of the original propety’s items, files, reminders and other settings. After duplication the two properties will not be related, so changes in one will be independent from the other.")]]))